import styles from './index.module.sass';
import bgEmpty from '@@/mixing/components/recipes-detail/icons/bg-0.svg';
import bgSell from '@@/mixing/components/recipes-detail/icons/bg-1.svg';
import bgMix from '@@/mixing/components/recipes-detail/icons/bg-2.svg';
import classNames from 'classnames';
import { useState } from 'react';
import {
  BestPriceBuyerItem,
  IBestPriceBagItem,
} from '@/modules/mixing/store/analytical-mixing.store';
import { useStore } from 'effector-react';
import {
  $moistureChangesDensity,
  $selectedRecipeStore,
} from '@/modules/mixing/store/recipes.store';
import { useNavigate } from 'react-router-dom';
import { useWindowDimensions } from '@/modules/common/hooks/use-window-dimensions.hook';
import { MainInfo } from './components/main-info';
import { WheatInfo } from './components/wheat-info';
import { TargetHumidity } from './components/target-humidity';
import { BuyerInfo } from './components/buyer-info';
import { BusinessInfo } from './components/business-info';
import { ActionArea } from './components/action-area';
import { ActionModal } from './components/action-modal/index.component';

// const agricultureParametersService = DiContainer.get(AgricultureParametersService);

export const SleeveItem = ({
  id,
  offer,
  action,
  data,
  setActiveTab,
  selectedToView,
  ref,
  loading,
}: IArgs) => {
  const TARGET_MOISTURE = +data.offer_humidity; //14;
  const price_after_moisture_mod =
    (data.weight + data.weight_gain_tons) * Number(offer?.price_per_ton) -
    data.freight_cost_after_moisture_mod;

  const price_before_moisture_mod =
    (data.weight + data.weight_gain_tons) * Number(offer?.price_per_ton) -
    data.freight_cost_before_moisture_mod;

  const [modalOpen, setModalOpen] = useState(false);
  const [modalViewOnly, setModalViewOnly] = useState(false);
  const [actionState, setActionState] = useState<'drain' | 'hydrate' | null>(
    +TARGET_MOISTURE < +data.values.humidity
      ? 'drain'
      : +TARGET_MOISTURE === +data.values.humidity
      ? null
      : 'hydrate',
  );
  const [viewPresellWarning, setViewPresellWarning] = useState(false);
  const activeWarehouse = useStore($selectedRecipeStore);
  const moistureChangesDensity = useStore($moistureChangesDensity);
  const isStationary = activeWarehouse?.type === '1';

  // const humidityDifference = data.values.humidity >
  return (
    <div
      className={classNames(
        styles.root,
        selectedToView && styles.selected,
        action?.type === 'mix' && styles.mixCase,
        action === undefined && styles.noCase,
      )}
      id={id}
      ref={ref}
    >
      <MainInfo
        className={classNames(
          selectedToView && styles.selected,
          action?.type === 'mix' && styles.mixCase,
          action === undefined && styles.noCase,
        )}
        id={id}
        isStationary={isStationary}
        data={data}
      />
      <WheatInfo
        className={classNames(
          selectedToView && styles.selected,
          action?.type === 'mix' && styles.mixCase,
          action === undefined && styles.noCase,
        )}
        isStationary={isStationary}
        data={data}
        offer={offer}
      />
      {(action?.type === 'sell' || action?.type === 'busy') && (
        <TargetHumidity
          className={classNames(
            selectedToView && styles.selected,
            // action?.type === 'mix' && styles.mixCase,
            action === undefined && styles.noCase,
          )}
          TARGET_MOISTURE={TARGET_MOISTURE}
          data={data}
          offer={offer}
        />
      )}
      {action?.type === 'sell' || action?.type === 'busy' ? (
        <>
          <BuyerInfo
            className={classNames(
              selectedToView && styles.selected,
              action === undefined && styles.noCase,
            )}
            data={data}
            offer={offer}
            TARGET_MOISTURE={TARGET_MOISTURE}
          />
          <BusinessInfo
            className={classNames(
              selectedToView && styles.selected,
              action === undefined && styles.noCase,
            )}
            actionState={actionState}
            data={data}
            offer={offer}
            price_after_moisture_mod={price_after_moisture_mod}
            price_before_moisture_mod={price_before_moisture_mod}
            isStationary={isStationary}
            setActionState={setActionState}
            setModalOpen={setModalOpen}
            setModalViewOnly={setModalViewOnly}
            TARGET_MOISTURE={TARGET_MOISTURE}
          />
        </>
      ) : action?.type === 'mix' ? (
        <div className={styles.note}>
          <span className={styles.label}>
            {data.is_wheat
              ? isStationary
                ? 'Нет предложений от покупателей о покупке данного объема'
                : 'Нет предложений от покупателей о покупке рукава'
              : 'Нет предложений от покупателей о покупке данного типа культуры'}
          </span>
          <span className={styles.value}>
            {getRecipeDeclension(data.mixes.length)[0]} {data.mixes.length}{' '}
            {getRecipeDeclension(data.mixes.length)[1]} микса с этим зерном
          </span>
        </div>
      ) : (
        <div className={styles.note}>
          <span className={styles.label}>
            {data.is_wheat
              ? isStationary
                ? 'Нет предложений от покупателей о покупке данного объема'
                : 'Нет предложений от покупателей о покупке рукава'
              : 'Нет предложений от покупателей о покупке данного типа культуры'}
          </span>
          {data.is_wheat ? (
            <span className={styles.value}>
              К сожалению это зерно не используется в рецептах для миксования
            </span>
          ) : (
            ''
          )}
        </div>
      )}
      {action?.onClick && (
        <ActionArea
          offer={offer}
          data={data}
          setViewPresellWarning={setViewPresellWarning}
          TARGET_MOISTURE={TARGET_MOISTURE}
          action={action}
          setModalOpen={setModalOpen}
          setActionState={setActionState}
          setActiveTab={setActiveTab}
          setModalViewOnly={setModalViewOnly}
          moistureChangesDensity={moistureChangesDensity}
          loading={loading}
        />
      )}
      {action?.type === 'sell' || action?.type === 'busy' ? (
        <img className={styles.bgImg} src={bgSell} />
      ) : action?.type === 'mix' ? (
        <img className={styles.bgImg} src={bgMix} />
      ) : (
        <img className={styles.bgImg} src={bgEmpty} />
      )}
      <ActionModal
        setViewPresellWarning={setViewPresellWarning}
        viewPresellWarning={viewPresellWarning}
        setModalOpen={setModalOpen}
        setActionState={setActionState}
        setActiveTab={setActiveTab}
        setModalViewOnly={setModalViewOnly}
        offer={offer}
        data={data}
        moistureChangesDensity={moistureChangesDensity}
        TARGET_MOISTURE={TARGET_MOISTURE}
        price_after_moisture_mod={price_after_moisture_mod}
        price_before_moisture_mod={price_before_moisture_mod}
        modalOpen={modalOpen}
        actionState={actionState}
        modalViewOnly={modalViewOnly}
      />
    </div>
  );
};

interface IArgs {
  id: string;
  offer?: BestPriceBuyerItem;
  action?: {
    type: 'mix' | 'sell' | 'busy';
    onClick: () => void;
  };
  data: IBestPriceBagItem;
  setActiveTab: (val: number) => void;
  selectedToView?: boolean;
  ref?: any;
  loading: boolean;
}

function getRecipeDeclension(count: number) {
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return ['Доступно', 'рецептов'];
  } else if (lastDigit === 1) {
    return ['Доступен', 'рецепт'];
  } else if (lastDigit >= 2 && lastDigit <= 4) {
    return ['Доступно', 'рецепта'];
  } else {
    return ['Доступно', 'рецептов'];
  }
}
